module.exports = __webpack_public_path__ + "static/media/lance-coury-loop-1.02b9582e.jpg";